import { render, staticRenderFns } from "./IncidentLogButton.vue?vue&type=template&id=cf141b4a"
import script from "./IncidentLogButton.vue?vue&type=script&lang=js"
export * from "./IncidentLogButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports